var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloneWheel(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1115_41663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4637 3.84755C9.24998 3.94757 8.92092 3.94411 8.70979 3.83852C7.99435 3.48215 7.18965 3.2793 6.33637 3.2793C3.37781 3.27924 0.979126 5.67781 0.979126 8.63614C0.979126 11.5948 3.37743 13.9934 6.33637 13.9934C7.1897 13.9934 7.9944 13.7901 8.70979 13.4336C8.92087 13.3286 9.24992 13.3244 9.4637 13.425C10.1413 13.7431 10.8962 13.9225 11.6931 13.9225C14.6081 13.9225 16.9792 11.5511 16.9792 8.63609C16.9792 5.72141 14.6081 3.35 11.6931 3.35C10.8962 3.35005 10.1413 3.52959 9.4637 3.84755ZM10.1738 12.9007C9.95157 12.8207 9.92685 12.6155 10.0949 12.4499C11.0808 11.4786 11.6925 10.1293 11.6925 8.63614C11.6925 7.14305 11.0807 5.79411 10.0949 4.8227C9.92685 4.6569 9.95157 4.45172 10.1738 4.37194C10.649 4.20051 11.1593 4.1052 11.6925 4.1052C14.1908 4.1052 16.2238 6.13755 16.2238 8.63587C16.2238 11.1344 14.1908 13.1668 11.6925 13.1668C11.1593 13.1668 10.649 13.0718 10.1738 12.9007Z",
    fill: "#5A1B97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1115_41663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.979126 0.63623)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneWheel);
export default __webpack_public_path__ + "static/media/CloneWheel.b88481b84115d7d9d92035724b402fa8.svg";
export { ForwardRef as ReactComponent };